module.exports = __webpack_public_path__ + "img/page2-img.56ec2262.png";